import { render, staticRenderFns } from "./DevDialogs.vue?vue&type=template&id=442a616c&lang=pug&"
import script from "./DevDialogs.vue?vue&type=script&lang=ts&"
export * from "./DevDialogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports